

<div class="mat-typography">
	<p  fxFlex="30">In mappa sono presenti i principali lavori stradali in corso e in programma a Bologna nelle prossime settimane. In caso di maltempo alcuni dei cantieri potrebbero essere ricalendarizzati. </p>
</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>